import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { useAuthContextV2 } from "../../../../../../auth-state";
import { default as tenantManagementClient } from "../../../../../../application/apis/tenant-management/tenant-management-client";
import { CloudGovApiError } from "../../../../../../application/domain/api-error";

type Props = {
  orgId: string;
};

export const useEnablePaymentHooks = ({ orgId }: Props) => {
  const authContext = useAuthContextV2();
  const [enablePayment, setEnablePayment] = useState(
    authContext.auth.usePayment,
  );

  // service provider account ログイン時は、authContextに決済情報が取得出来ないので直接APIから情報を取得し判定する
  const fetchPaymentSetting = useCallback(async () => {
    try {
      const { data: paymentSetting } =
        await tenantManagementClient.fetchOrgPaymentSetting(orgId);

      setEnablePayment(
        !!paymentSetting &&
          !!paymentSetting.sbpsMerchantId &&
          !!paymentSetting.sbpsServiceId,
      );
    } catch (e) {
      if (CloudGovApiError.is404(e)) {
        setEnablePayment(false);
      } else {
        toast.error(
          "決済設定情報の取得に失敗しました。時間を空けて再度お試しください。",
        );
      }
    }
  }, [orgId]);

  useEffect(() => {
    if (authContext.auth.isServiceProviderAccount()) {
      fetchPaymentSetting();
    }
  }, [authContext.auth, fetchPaymentSetting]);

  return {
    enablePayment,
  };
};
